import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as actions from './actions'
import * as profileActions from '../../containers/SignInPage/actions'
import {
  InitialState,
  ParentDataType,
  PayloadCreateDataType,
  PayloadEditDataType,
} from './types'
import * as profileTypes from '../../containers/SignInPage/types'

// Styles
import './styles.scss'

// Components
import Header from '../../components/Header'
import ProfileHeader from '../../components/ProfileHeader'
import Footer from '../../components/Footer'
import AvatarParentBlock from '../../components/AvatarParentBlock'
import PersonalParentBlock from '../../components/PersonalParentBlock'
import ContactsParentBlock from '../../components/ContactsParentBlock'
import PageLoading from '../../components/LoadingPage'
import Loading from '../../components/Loading'
import notification from '../../components/Notification'

// Images
import Background from './images/background'
import IconDad from './images/iconDad'
import IconMother from './images/iconMother'
import IconCopy from '../../components/ModalInvite/images/iconCopy'

export default () => {
  const [dadData, setDadData] = useState<ParentDataType>(null)
  const [motherData, setMotherData] = useState<ParentDataType>(null)
  const [isLoaded, setIsLoaded] = useState<boolean>(false)

  const dispatch = useDispatch()
  const isMounted = useRef<boolean>(false)

  const { parents, parentsIsProcess, error } = useSelector(
    (state: { profileParents: InitialState }) => state.profileParents
  )

  const { isProcessSendInvite, sendInviteComplete } = useSelector(
    (state: { profile: profileTypes.InitialState }) => state.profile
  )

  useEffect(() => {
    if (sendInviteComplete) {
      notification(<IconCopy />, '', 'Приглашение отправлено!')
      dispatch(profileActions.sendParentInviteDestroy())
    }
  }, [sendInviteComplete])

  useEffect(() => {
    dispatch(actions.destroy())
    dispatch(actions.fetchParents())
    isMounted.current = true
    return () => {
      dispatch(actions.destroy())
    }
  }, [])

  useEffect(() => {
    if (isMounted.current && parents && Array.isArray(parents)) {
      parents.forEach(parent => {
        const {
          profile_id,
          short_id,
          first_name,
          middle_name,
          last_name,
          birthdate,
          contact_email,
          contact_phone,
          avatar_url,
          photo,
        } = parent

        const parentData: ParentDataType = {
          profile_id,
          short_id,
          first_name,
          middle_name,
          last_name,
          birthdate,
          contact_email,
          contact_phone,
          avatar_url,
          photo,
        }

        if (parent.gender === 'male') {
          setDadData(parentData)
        }

        if (parent.gender === 'female') {
          setMotherData(parentData)
        }
      })
      setIsLoaded(true)
    }
  }, [parents])

  const createProfile = (data: PayloadCreateDataType) => {
    const {
      gender,
      first_name,
      middle_name,
      last_name,
      birthdate,
      contact_email,
      contact_phone,
    } = data
    dispatch(
      actions.createParent(
        gender,
        first_name || undefined,
        middle_name || undefined,
        last_name || undefined,
        birthdate || undefined,
        contact_email || undefined,
        contact_phone || undefined
      )
    )
  }

  const saveProfile = (data: PayloadEditDataType) => {
    const {
      parent_id,
      gender,
      first_name,
      middle_name,
      last_name,
      birthdate,
      contact_email,
      contact_phone,
    } = data
    dispatch(
      actions.editParent(
        parent_id,
        gender,
        first_name || undefined,
        middle_name || undefined,
        last_name || undefined,
        birthdate || undefined,
        contact_email || undefined,
        contact_phone || undefined
      )
    )
  }

  const handleUploadPhoto = (parent_id: string, photo: File) => {
    dispatch(actions.uploadPhoto(parent_id, photo))
  }

  const handleRemovePhoto = (parent_id: string) => {
    dispatch(actions.removePhoto(parent_id))
  }

  return (
    <>
      <Header />
      <div className={'profile'}>
        <div className={'container'}>
          <ProfileHeader style={{ marginBottom: 44 }} />
          {(!isMounted.current || parentsIsProcess) && !isLoaded ? (
            <PageLoading />
          ) : (
            <div className={'profile-parents'}>
              <div className={'profile-parents__center'}>
                <Background />
              </div>
              <div className={'profile-parents__row'}>
                <div className={'profile-parents__row-item'}>
                  <AvatarParentBlock
                    icon={<IconDad />}
                    title={'Папа'}
                    parentData={dadData}
                    colorButton={'rgba(25, 120, 178, 0.15)'}
                    onUpload={(profile_id, photo) =>
                      handleUploadPhoto(profile_id, photo)
                    }
                    editIsHidden={!dadData}
                    onRemove={profile_id => handleRemovePhoto(profile_id)}
                  />
                  <PersonalParentBlock
                    title={'Папа'}
                    colorEditIcon={'#1978B2'}
                    colorInput={'rgba(25, 120, 178, 0.15)'}
                    gender={'male'}
                    parentData={dadData}
                    onCreate={createProfile}
                    onSave={saveProfile}
                  />
                  <ContactsParentBlock
                    style={{ background: '#DDEBF4' }}
                    colorEditIcon={'#1978B2'}
                    colorInput={'rgba(25, 120, 178, 0.15)'}
                    gender={'male'}
                    parentData={dadData}
                    onCreate={createProfile}
                    onSave={saveProfile}
                  />
                  <div
                    onClick={() => {
                      if (
                        dadData?.contact_email &&
                        isProcessSendInvite !== 'father'
                      ) {
                        dispatch(
                          profileActions.sendParentInvite(
                            'father',
                            dadData.contact_email
                          )
                        )
                      }
                    }}
                    className={
                      dadData?.contact_email && !dadData?.short_id
                        ? 'parent__invite'
                        : 'parent__invite disabled'
                    }
                  >
                    {isProcessSendInvite === 'father' ? (
                      <Loading style={{ margin: 0 }} color={'#1978B2'} />
                    ) : (
                      'Пригласить папу'
                    )}
                  </div>
                </div>
                <div className={'profile-parents__row-item'}>
                  <AvatarParentBlock
                    icon={<IconMother />}
                    title={'Мама'}
                    parentData={motherData}
                    style={{ background: '#DEEFDE' }}
                    colorIconEdit={'#219321'}
                    onUpload={(profile_id, photo) =>
                      handleUploadPhoto(profile_id, photo)
                    }
                    onRemove={profile_id => handleRemovePhoto(profile_id)}
                    editIsHidden={!motherData}
                  />
                  <PersonalParentBlock
                    title={'Мама'}
                    style={{ background: '#DEEFDE' }}
                    colorEditIcon={'#219321'}
                    colorInput={'rgba(33, 147, 33, 0.15)'}
                    gender={'female'}
                    parentData={motherData}
                    onCreate={createProfile}
                    onSave={saveProfile}
                  />
                  <ContactsParentBlock
                    style={{ background: '#DEEFDE' }}
                    colorEditIcon={'#219321'}
                    colorInput={'rgba(33, 147, 33, 0.15)'}
                    gender={'female'}
                    parentData={motherData}
                    onCreate={createProfile}
                    onSave={saveProfile}
                  />
                  <div
                    onClick={() => {
                      if (
                        motherData?.contact_email &&
                        isProcessSendInvite !== 'mother'
                      ) {
                        dispatch(
                          profileActions.sendParentInvite(
                            'mother',
                            motherData.contact_email
                          )
                        )
                      }
                    }}
                    className={
                      motherData?.contact_email && !motherData?.short_id
                        ? 'parent__invite mother'
                        : 'parent__invite mother disabled'
                    }
                  >
                    {isProcessSendInvite === 'mother' ? (
                      <Loading style={{ margin: 0 }} color={'#E84E25'} />
                    ) : (
                      'Пригласить маму'
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        {error ? <span style={{ color: 'red' }}>{error}</span> : null}
      </div>
      <Footer />
    </>
  )
}
